var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.22 8.43109H25.3478C26.5883 8.43109 27.6033 9.44609 27.6033 10.6866V26.4755C27.6033 27.7161 26.5883 28.7311 25.3478 28.7311H9.5589C8.31834 28.7311 7.30334 27.7161 7.30334 26.4755V10.6866C7.30334 9.44609 8.31834 8.43109 9.5589 8.43109H10.6867V6.17554H12.9422V8.43109H21.9645V6.17554H24.22V8.43109ZM9.5589 26.4755H25.3478V15.1978H9.5589V26.4755ZM9.5589 12.9422V10.6866H25.3478V12.9422H9.5589ZM22.5171 18.051L15.8293 24.7388L12.2543 21.1637L13.4497 19.9683L15.8293 22.3479L21.3216 16.8556L22.5171 18.051Z",
    fill: "#14171F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.fb5af2e44652705625f2dfec37da3f18.svg";
export { ForwardRef as ReactComponent };